import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { PrimeReactProvider } from 'primereact/api';
import App from './App.tsx';
import * as Sentry from '@sentry/react';

const isProd = import.meta.env.MODE === 'production';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.captureConsoleIntegration({
      levels: ['error']
    })
  ],
  enabled: isProd
});

// After a deploy, a tab still running the previous build requests lazy chunks that
// no longer exist. Reload once to pick up the new build; the timestamp guard stops a
// reload loop if the chunk is genuinely broken.
window.addEventListener('vite:preloadError', (event) => {
  const lastReloadAt = Number(sessionStorage.getItem('chunkReloadAt') ?? 0);
  if (Date.now() - lastReloadAt < 10_000) return;

  sessionStorage.setItem('chunkReloadAt', String(Date.now()));
  event.preventDefault();
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Произошла непредвиденная ошибка</p>}>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
